import React, { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";

const CurrentDate = () => {
  // State to hold the current date
  const [currentDate, setCurrentDate] = useState(new Date());

  const colourTheme = useTheme();

  // useEffect to update the date daily
  useEffect(() => {
    // Function to update the current date
    const updateDate = () => {
      setCurrentDate(new Date());
    };

    // Create an interval to update time daily (86400000ms = 24hrs)
    const intervalId = setInterval(updateDate, 86400000); // Update every 24 hours

    // Update date when component mounts and clean up interval on unmount
    updateDate();
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array to only run once on mount

  // Manually format the date: 'Thursday, 9th May'
  const formatDate = (date) => {
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayOfWeek = dayNames[date.getDay()]; // e.g. Thursday
    const day = date.getDate(); // e.g. 9
    const month = monthNames[date.getMonth()]; // e.g. May

    // Handle ordinal suffix for day (e.g. 1st, 2nd, 3rd, etc.)
    const suffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${dayOfWeek}, ${day}${suffix(day)} ${month}`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "1rem",
      }}
    >
      <Box
        sx={{
          backdropFilter: "blur(1rem)",
          boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
          fontSize: "0.75rem",
          border: `1px solid ${colourTheme.palette.text.primary}`,
          borderRadius: "1rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "fit-content",
          paddingLeft: "0.5rem",
          paddingRight: "0.5rem",
        }}
      >
        <p style={{ margin: "0.125rem" }}>{formatDate(currentDate)}</p>
      </Box>
    </Box>
  );
};

export default CurrentDate;
